import React from "react";
import Radio from "@mui/material/Radio";
import Box from "@mui/material/Box";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import SharePointIcon from "../../../../../../../../components/CustomIcons/SharePointIcon";
import RadioGroup, { useRadioGroup } from "@mui/material/RadioGroup";
import { styled } from "@mui/material/styles";
import StorageIcon from "@mui/icons-material/Storage";

export default function DrawingsSource({ source, setSource }) {
  const handleChange = (event) => {
    setSource(event.target.value);
  };

  return (
    <FormControl sx={{ mr: 1, borderRight: "1px solid #777" }}>
      <RadioGroup value={source} onChange={handleChange}>
        <Box>
          <SharePointIcon
            size={23}
            sx={{ float: "left", transform: "translateY(7px)", mr: 1 }}
          />
          <MyFormControlLabel
            value="sharepoint"
            control={<Radio />}
            label="Sharepoint"
            // labelPlacement="start"
          />
        </Box>

        <Box>
          <StorageIcon
            sx={{ color: "blue", transform: "translateY(6px)", mr: 1.3 }}
          />
          <MyFormControlLabel
            value="database"
            control={<Radio />}
            label="Database"
            // labelPlacement="start"
          />
        </Box>
      </RadioGroup>
    </FormControl>
  );
}

function MyFormControlLabel(props) {
  const radioGroup = useRadioGroup();

  let checked = false;

  if (radioGroup) {
    checked = radioGroup.value === props.value;
  }

  return <StyledFormControlLabel checked={checked} {...props} />;
}

const StyledFormControlLabel = styled((props) => (
  <>
    <FormControlLabel {...props} />
  </>
))(({ theme }) => ({
  variants: [
    {
      props: { checked: true },
      style: {
        ".MuiFormControlLabel-label": {
          color: theme.palette.primary.main,
          display: "inline-block",
        },
      },
    },
  ],
}));
